import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const PaymentSuccessfully = () => {
    document.title = 'MACRUM | Payment Successfully'
    document.querySelector('meta[rel="canonical"]').setAttribute('href', 'https://macrum.in/payment-success')
    const navigate = useNavigate()
    const {order} = useSelector((store) => store.order)

    const handleBack = () => {
        navigate('/')
    }

  return (
    <div className='pt-32'>
        <div className='w-fit px-4 lg:px-16 py-4 mt-4 mx-auto'>
            <div className='px-12 lg:px-14 py-4 border-2 bg-blue-950 border-blue-800 rounded-xl'>
                <h5 className='text-slate-400 text-xl font-semibold'>Thank you for purchase software</h5>
                <p className='text-slate-400 px-6 py-1'>Payment Id : {order.data.paymentInfo.paymentId}</p>
            </div>
        </div>
        <div className='w-fit py-10 mx-auto'>
            <button
                onClick={handleBack}
                className='bg-blue-950 border-blue-800 text-lg border rounded py-2 px-8 font-semibold'
                type='button'
            >
                Back
            </button>
        </div>
    </div>
  )
}

export default PaymentSuccessfully
